import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("errah_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const track = (event, meta = {}) => {
  try {
    const source = new URLSearchParams(window.location.search).get("utm_source") || "Website";
    api.post("/track", { event, meta, source }).catch(() => {});
  } catch (_) {}
};
